import React from 'react'
import { Switch, Route } from 'react-router-dom'
import EnrollmentView from 'views/enrollment-views'

export const EnrollmentLayout = () => {
  
  return (
    <div id="zig-enrollment-layout-root" className="auth-container">
      <Switch>
        <Route path="" component={EnrollmentView} />
      </Switch>
    </div>
  )
}

export default EnrollmentLayout
